import { ToasterConfig } from './toaster-config.model';
import { StripMethods, DataPartial } from '@webtronic-labs/contracts-proflyt';
import { ToasterType } from '../../enums';

export class ToasterConfigMock extends ToasterConfig {
  constructor(data?: DataPartial<ToasterConfig>) {
    const seedData: StripMethods<ToasterConfig> = {
      ...data,
      title: 'Hello there',
      content: 'Content placeholder',
      type: ToasterType.Default,
      timeout: 10000,
      id: 'uniqueID',
      destroyed: false,
    };
    super(seedData);
  }
}
